import { word } from "@modules/core/utils/i18n"
import { RpeSlider } from "@modules/sessionBlock/exercises/components/rpeSlider"
import { ExerciseFormikType } from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { HUText } from "@modules/ui/components/huText"
import { InputSwitch } from "primereact/inputswitch"
import { useMemo } from "react"
import { useTheme } from "styled-components"

type RpeBlocProps = {}

export const RpeBloc: React.FC<RpeBlocProps> = () => {
  const theme = useTheme()

  const { formik, updatedBlockIndex } = useSessionFormContext()

  const currentExercise = useMemo(() => {
    return updatedBlockIndex !== null && (formik.values.blocks[updatedBlockIndex]?.content as ExerciseFormikType)
  }, [updatedBlockIndex, formik])

  const isRpe = useMemo(() => {
    if (typeof currentExercise === "object" && currentExercise.rpe !== null && "rpe" in currentExercise) {
      return true
    } else {
      return false
    }
  }, [currentExercise])

  const onRpe = () => {
    if (isRpe === true) {
      formik.setFieldValue(`blocks[${updatedBlockIndex}].content.rpe`, null)
    } else {
      formik.setFieldValue(`blocks[${updatedBlockIndex}].content.rpe`, 5)
    }
  }

  return (
    <div className="card flex-1 mb-0 py-3 px-4 transition-duration-300 transition-all" style={{ height: 280 }}>
      <HUText type="label" color={theme.neutralColor700} fontStyle="LS" style={{ lineHeight: "21px", marginBottom: 7 }}>
        {word("sessionForm.exercise.rpe.label").toUpperCase()}
      </HUText>
      <div className="flex w-full justify-content-between mb-2">
        <HUText type="label" className="my-1" color={theme.neutralColor700} fontStyle="LL">
          {word("sessionForm.exercise.askRpe")}
        </HUText>
        <InputSwitch checked={isRpe} onChange={onRpe} />
      </div>
      <HUText type="label" color={theme.neutralColor600} fontStyle="BS">
        {word("sessionForm.exercise.rpe.description")}
      </HUText>
      <RpeSlider isRpe={isRpe} />
    </div>
  )
}
